import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationStateService {
  private visitedHospitalLobby = new BehaviorSubject<boolean>(false);

  setVisitedHospitalLobby(visited: boolean) {
    this.visitedHospitalLobby.next(visited);
  }

  hasVisitedHospitalLobby() {
    return this.visitedHospitalLobby.asObservable();
  }
}